export function getUserAgent(): string {
  return navigator.userAgent;
}
